export interface BalanceWidgetConfig {
  countSkins: number;
  countCoins: number;
  urlSkins?: string;
  urlCoins?: string;
}
